import Vue from 'vue';

import {
  CustomInput,
  PersonalDataTitle,
} from '@/components';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  required,
  email,
  regex,
} from 'vee-validate/dist/rules';

export default {
  name: 'PersonalDataForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    [CustomInput.name]: CustomInput,
    [PersonalDataTitle.name]: PersonalDataTitle,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      language: 'getLanguage',
      personalDataState: 'getPersonalData',
      customerDataRaw: 'getCustomerDataRaw',
      vehiculeType: 'getVehiculeType',
      serviceType: 'getServiceType',
    }),
    ...mapGetters('leasingCompany', {
      leasingCompanies: 'getLeasingCompanies',
    }),
    leasingCompanyId: {
      get() {
        return this.personalDataState.leasingCompanyId;
      },
      set(newModel) {
        if (newModel != null) {
          const changePersonalDataStateObject = {
            state: newModel,
            property: 'leasingCompanyId',
          };

          this.setPersonalDataMutation(changePersonalDataStateObject);
        }

        return newModel;
      },
    },
    isLeaseFleet() {
      return this.vehiculeType === 'lease' || this.vehiculeType === 'fleet';
    },
    showLeasingFields() {
      if (this.customerDataRaw.customerType === 'unknown' && this.serviceType === 'maintenance' && this.vehiculeType === 'part') {
        return false;
      }
      return this.customerDataRaw.customerType === 'unknown' || this.customerDataRaw.customerType === 'lease';
    },
    disableLeasingFields() {
      // Bestaande lease kan ze niet aanpassen
      return this.customerDataRaw.customerType === 'lease';
    },
  },
  methods: {
    ...mapActions('leasingCompany', {
      getLeasingCompanies: 'FETCH_DATA_LEASING_COMPANIES',
    }),
    save() {},
    setValidationMessages() {
      // Vee-validate
      // Translations are added in the PersonalDataFormComponent
      extend('required', {
        ...required,
        message: Vue.prototype.$gettext('Validation - Required error'),
      });

      extend('email', {
        ...email,
        message: Vue.prototype.$gettext('Validation - Email error'),
      });

      extend('regex', {
        ...regex,
        message: Vue.prototype.$gettext('Validation - Regex error'),
      });

      extend('objectNotEmpty', {
        validate: (value) => {
          if (value !== 0) {
            return true;
          }

          return Vue.prototype.$gettext('Validation - Leasing company');
        },
      });
    },
    ...mapMutations('appointment', {
      setPersonalDataMutation: 'SET_PERSONALDATA',
    }),
  },
  watch: {
    language() {
      this.setValidationMessages();
    },
  },
  created() {
    this.setValidationMessages();

    if (this.leasingCompanies.length === 0) {
      this.getLeasingCompanies();
    }
  },
};
